import { PasswordPolicy } from "../models";

const getQueryVariable = (variable: string) => {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
      var pair = vars[i].split("=");
      if(pair[0] === variable) {return pair[1];}
    }
    return "";
  }

 export const getRedirectUrl = () => {
    let redirectUrl = getQueryVariable("returnTo");
    if (!redirectUrl) {
      redirectUrl = "https://rplportalstatic0.blob.core.windows.net/pages/landing.html"
    } else {
      try {
        redirectUrl = atob(decodeURIComponent(redirectUrl));
      } catch {
        redirectUrl = atob(redirectUrl);
      }
    }
    return redirectUrl;
 }

/** 
* Parse JWT token for UI uses only!
* This is not secure, the whole token needs to be sent to backend to validate against secret
*/
export const parseJwt = (token: string) => {
  // Use browser's atob() instead of Node.js Buffer for browser compatibility
  // JWT tokens use base64url encoding, so we need to convert to standard base64
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  // Add padding if needed
  const padded = base64 + '='.repeat((4 - base64.length % 4) % 4);
  const decoded = atob(padded);
  return JSON.parse(decoded);
}

export const validatePassword = (password: string, policy: PasswordPolicy) => {
  if (!password) return false;
  const exp = new RegExp(`${policy.pattern}`, 'g');
  return Boolean(password.match(exp));
}


const normalizeTranslationVariables = (variables: Record<string, string>) =>
  Object.fromEntries(
    Object.entries(variables).map(([key, value]) => [
      key.replace(/^\{|\}$/g, ""),
      value,
    ])
  );

export const translateError = (t: any, error: any, falback: string = "") => {
  let errMsg;

  if (error.response && error.response.data && error.response.data.error) {
    error = error.response.data.error;
    if (error.translation) {
        const variables = error.translation.variables
          ? normalizeTranslationVariables(error.translation.variables)
          : undefined;
        errMsg = t([error.translation.code, error.message], variables);
    } else {
      errMsg = error.message;
    }
  } else {
    errMsg = error.message;
  }

  if (!errMsg) errMsg = falback;

  return errMsg;
}
